import type { IntersectionDefinition } from '../types/intersection';
import type { PositionOverride } from './overridesRuntime';

/**
 * Aplica correcciones de posición GPS sobre el dataset generado, calculando
 * el delta entre la posición vieja del cabinet y la nueva, y trasladando ese
 * mismo delta a los 4 `groups[].position` (offsets sintéticos fijos respecto
 * al cabinet — sin esto quedarían "descolgados") y, si `moveCenter`, también
 * a `center` (encuadre de cámara del fly-to).
 */
export function applyPositionOverrides(
  base: IntersectionDefinition[],
  overrides: PositionOverride[],
): IntersectionDefinition[] {
  if (overrides.length === 0) return base;
  const byId = new Map(overrides.map(o => [o.logicalId, o]));

  return base.map((ix) => {
    const override = byId.get(ix.cabinet.logicalId);
    if (!override) return ix;

    const [oldLng, oldLat] = ix.cabinet.position;
    const [newLng, newLat] = override.cabinet;
    const dLng = newLng - oldLng;
    const dLat = newLat - oldLat;

    return {
      ...ix,
      center: override.moveCenter
        ? [ix.center[0] + dLng, ix.center[1] + dLat]
        : ix.center,
      cabinet: { ...ix.cabinet, position: [newLng, newLat] },
      groups: ix.groups.map(g => ({
        ...g,
        position: [g.position[0] + dLng, g.position[1] + dLat],
      })),
    };
  });
}
